// extracted by mini-css-extract-plugin
module.exports = {"root":"RivenditoreMapModal_root__i5hXd","head":"RivenditoreMapModal_head__jMPhd","close":"RivenditoreMapModal_close__QnMj_","rotation":"RivenditoreMapModal_rotation__k491S"};